import React from 'react'
import type { NextPage } from 'next'
import Meta from '@g4g/ui/src/internal/head/Meta'
import RecipientContent from '../../components/recipient/page/RecipientContent'

const Recipient: NextPage = () => {
  return (
    <>
      <Meta
        app="shop"
        title="Select Purchase Recipient | Mobile Minigames Shop"
        canonical="https://shop.mobileminigames.com/deals"
        socialMediaImage={
          (process.env.NEXT_PUBLIC_SHOP_APP_URL ?? 'https://shop.mobileminigames.com') +
          '/shop_app_social.jpg'
        }
        socialMediaImageAlt="Mobile Minigames Shop"
      />
      <RecipientContent />
    </>
  )
}

export default Recipient
